(function () {
  function initAccordion(root) {
    var groups = root.querySelectorAll("[data-hto-accordion]");
    groups.forEach(function (group) {
      if (group.dataset.htoAccordionReady === "true") return;
      group.dataset.htoAccordionReady = "true";

      group.addEventListener("click", function (event) {
        var header = event.target.closest(".hto-usp__header");
        if (!header || !group.contains(header)) return;

        var item = header.closest(".hto-usp--accordion");
        if (!item) return;

        var isOpen = item.classList.toggle("is-open");
        header.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
    });
  }

  if (document.readyState !== "loading") {
    initAccordion(document);
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      initAccordion(document);
    });
  }

  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener("shopify:section:load", function (event) {
    initAccordion(event.target);
  });
})();
